import { Toast } from '../../scripts/models/toast';

export const DEFAULT_TOAST_STATE: ToastState = {
  toasts: [],
};

export interface ToastState {
  toasts: Toast[];
}
